import { render, staticRenderFns } from "./IconSvgBinoculars.vue?vue&type=template&id=790c9abd&scoped=true&"
import script from "./IconSvgBinoculars.vue?vue&type=script&lang=js&"
export * from "./IconSvgBinoculars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c9abd",
  null
  
)

export default component.exports